import { BASE_LAYER_LABELS, type BaseLayerId } from "../editorTypes";

interface BaseLayerSwitcherProps {
  active: BaseLayerId;
  onChange: (id: BaseLayerId) => void;
}

const OPTIONS: BaseLayerId[] = ["google-satellite", "google-hybrid", "google-streets", "osm"];

export default function BaseLayerSwitcher({ active, onChange }: BaseLayerSwitcherProps) {
  return (
    <div className="absolute bottom-3 left-3 z-10 bg-white/95 backdrop-blur rounded-lg shadow-md border border-background-200/70 p-1 flex gap-1">
      {OPTIONS.map((id) => (
        <button
          key={id}
          onClick={() => onChange(id)}
          className={`px-2.5 py-1.5 text-[11px] font-medium rounded-md transition-colors cursor-pointer whitespace-nowrap ${
            active === id ? "bg-primary-500 text-white" : "text-foreground-600 hover:bg-background-100"
          }`}
        >
          {BASE_LAYER_LABELS[id]}
        </button>
      ))}
    </div>
  );
}
